import React, {useCallback} from 'react';
import {Chip, Tooltip} from "@mui/material";
import {Office} from "../../api/Model";
import EnvoyIcon from "../icons/EnvoyIcon";

export function officeGoogleMapLink(office: Office): string | null {
    return office.latitude && office.longitude ? `https://www.google.com/maps/search/?api=1&query=${office.latitude},${office.longitude}` : null;
}

export function OfficeChip({office}: { office: Office }) {
    const url = officeGoogleMapLink(office);

    const handleClick = useCallback(() => {
        if (url) {
            window.open(url, '_blank');
        }
    }, [url]);

    return (
        <Tooltip title={office.addressLineOne || 'No address'} arrow>
            <Chip
                icon={<EnvoyIcon fontSize="small" sx={{paddingLeft: 1}}/>}
                label={office.name}
                variant="outlined"
                onClick={url ? handleClick : undefined}
                sx={{
                    cursor: url ? 'pointer' : 'default',
                    '& .MuiChip-icon': {
                        color: 'inherit'
                    }
                }}
            />
        </Tooltip>
    );
}
